import { flushSync, mount } from "svelte";
import type { TransferState } from "@aasaan-share/ui-contract";
import ViewerRoot from "./svelte/ViewerRoot.svelte";
import type { ViewerUiModel } from "./models.ts";
import { viewerModel } from "./viewer-store.ts";

export class ViewerApp {
  constructor(private readonly root: HTMLElement) {
    mount(ViewerRoot, { target: root });
  }

  render(model: ViewerUiModel): void {
    flushSync(() => viewerModel.set(model));
  }

  updateTransfer(model: ViewerUiModel): boolean {
    const focusedAction = document.activeElement instanceof HTMLElement
      ? document.activeElement.dataset.action
      : undefined;
    this.render(model);
    if (
      isActiveTransfer(model.transferState)
      && (focusedAction === "download-photo" || focusedAction === "download-video")
    ) {
      this.root.querySelector<HTMLElement>("[data-action='cancel-download']")?.focus();
    }
    return true;
  }
}

function isActiveTransfer(state: TransferState | undefined): boolean {
  return state === "queued"
    || state === "starting"
    || state === "transferring"
    || state === "verifying";
}
